<template>
	<div style="margin: 0 auto;">
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div style="padding:6px 15px; ">
			<Form ref="searchForm" :model="searchForm" label-position="left" :label-width="70" inline>
				<FormItem label="手机号码"><Input type="text" v-model="searchForm.mobile" placeholder="手机号码" /></FormItem>
				<FormItem label="昵称"><Input type="text" v-model="searchForm.nickname" placeholder="昵称" /></FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('searchForm')">
						<Icon type="ios-search" />
						搜索
					</Button>
				</FormItem>
			</Form>
		</div>
		<Table :data="tableData2" :columns="tableColumns2" size="large" :loading="loading" header="header" footer="footer">
			<template slot-scope="{ row }" slot="Avatar">
				<Avatar :src="'http://cjb.xahulian.com/'+ row.avatar " size="large" v-if="row.avatar" />
				<Avatar icon="ios-person" size="large" v-else />
			</template>
			<template slot-scope="{ row }" slot="tg">
				<span>{{row.tg.yj}}</span> |
				<span>{{row.tg.ej}}</span>
			</template>
			<template slot-scope="{ row }" slot="action">
				<Button type="warning" @click="showModifyPass(row.uid)">
					修改密码
				</Button>
			</template>

			<template slot="header">
				<div class="flex justify-between">
					<div span="12">
					</div>
					<div span="12">
						<div style="text-align: right;">
							<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
							 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
						</div>
					</div>
				</div>

			</template>
			<template slot="footer">
				<div style="text-align: right;">
					<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
					 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
				</div>
			</template>
		</Table>
		<Modal v-model="modalModifyPass" title="修改密码" :footer-hide="true" :width="400">
			<div style="position: relative;">
				<Form ref="formModifyPass" :model="formModifyPass" label-position="right" :label-width="100" label-colon>
					<FormItem label="新密码">
						<Input v-model="formModifyPass.newpass" />
					</FormItem>
					<FormItem>
						<Button type="primary" @click="submitModifyPass('formModifyPass')" :loading="loadingModifyPass">提交</Button>
						<Button style="margin-left: 8px" @click="modalModifyPass=false">取消</Button>
					</FormItem>
				</Form>
				<Spin fix v-if="loadingModifyPass">
					<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
					<div>处理中...</div>
				</Spin>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				jczList: [],
				loading: false,
				tableColumns2: [{
						title: 'id',
						type: 'index',
						width: 58
					},

					{
						title: '头像',
						align: 'center',
						slot: 'Avatar',
						width: 150
					},
					{
						title: '昵称',
						align: 'center',
						key: 'nickname'
					},
					{
						title: '手机号',
						key: 'mobile',
						align: 'center'
					},
					{
						title: '性别',
						key: 'sex',
						align: 'center'
					},
					{
						title: '生日',
						key: 'birthday',
						align: 'center'
					},
					{
						title: '推广业绩',
						slot: 'tg',
						align: 'center'
					},
					{
						title: '积分',
						key: 'score',
						align: 'center'
					},
					{
						title: '下单数量',
						key: 'order',
						align: 'center'
					},
					{
						title: '注册时间',
						key: 'addtime',
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						align: 'center',
						width: 220

					}
				],
				tableData2: [],
				searchForm: {
					page: 1,
					size: 20,
					total: 0,
					mobile: '',
					nickname: ''
				},
				modalModifyPass: false,
				loadingModifyPass: false,
				formModifyPass: {
					uid: '',
					newpass: ''
				}
			};
		},
		methods: {
			showModifyPass(uid) {
				this.formModifyPass.uid = uid;
				this.modalModifyPass = true;
			},
			submitModifyPass() {
				var that = this;
				this.loadingModifyPass = true;
				this.$http.post('/server/api/client/user/index.php?a=modifypass', this.$qs.stringify(this.formModifyPass)).then(
					res => {
						this.loadingModifyPass = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.modalModifyPass = false;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loadingModifyPass = false;
						this.$Message.error('系统错误');
					}
				);
			},
			handleSubmit(name) {
				this.loadinfos();
				return false;
			},
			loadinfos() {
				var that = this;
				this.loading = true;
				this.$http.post('/server/api/client/user/index.php?a=list', this.$qs.stringify(this.searchForm)).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.searchForm.total = res.data.data.total;
							this.tableData2 = res.data.data.infos;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			pageChange(page) {
				this.searchForm.page = page;
				this.loadinfos();
			},
			pageSizeChange(size) {
				this.searchForm.size = size;
				this.loadinfos();
			}
		},
		created() {
			this.loadinfos();
		}
	};
</script>

<style>
	.demo-spin-icon-load {
		font-size: 5em;
		animation: ani-demo-spin 1s linear infinite;
	}
</style>
